import React, { Fragment } from 'react';
import T from 'prop-types';
import Item from './item';
import Pagination from '../Pagination';
import Spinner from '../Spinner';

const propTypes = {
  LinkText: T.string,
  LinkUrl: T.string,
  /** See <Item> component */
  SearchHits: T.array,
};

function focusLastItem() {
  document.getElementById('search-link__last-item').focus();
}

const ItemList = (props) => {
  const {
    LinkText,
    LinkUrl,
    SearchResult: { SearchHits, BatchText, NextPage },
  } = props;

  const renderItem = (item, idx) => (
    <Item key={item.URL} {...item} isLast={idx === SearchHits.length - 1} />
  );
  return (
    <Fragment>
      <ul className="link-item-list">{SearchHits.map(renderItem)}</ul>
      {(NextPage || (LinkUrl && LinkText)) && (
        <div className="link-item-list__ctrls">
          <div>
            {NextPage && (
              <Pagination
                Modifiers={{ 'link-item-list__btn': true }}
                onClick={focusLastItem}
                {...props.SearchResult}
                Spinner={<Spinner Modifiers={{ 'c-spinner--search': true }} />}
              >
                {BatchText}
              </Pagination>
            )}
            {LinkUrl && LinkText && (
              <a className="link-item-list__link" href={LinkUrl}>
                <span>{LinkText}</span>
              </a>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

ItemList.propTypes = propTypes;

ItemList.defaultProps = {};

export default ItemList;
